// extracted by mini-css-extract-plugin
module.exports = {"skipNav":"SkipNav_skipNav__35wh1"};